(function () {
  window.SPCLST = window.SPCLST || {};
  window.SPCLST.modules = window.SPCLST.modules || {};

  window.SPCLST.modules.featuredProducts = function (helpers) {
    var query = helpers.query;
    var queryAll = helpers.queryAll;
    var on = helpers.on;
    var parseBool = helpers.parseBool;
    var isMobileViewport = helpers.isMobileViewport;
    var isDesktopNavViewport = helpers.isDesktopNavViewport;

    queryAll('[data-spclst-featured-collection-slider]').forEach(function (sliderRoot) {
      if (sliderRoot.getAttribute('data-spclst-initialized') === 'true') return;
      sliderRoot.setAttribute('data-spclst-initialized', 'true');

      var viewport = query('[data-spclst-featured-collection-viewport]', sliderRoot);
      var track = query('[data-spclst-featured-collection-track]', sliderRoot);
      var slides = queryAll('[data-spclst-featured-collection-slide]', sliderRoot);
      var prevButton = query('[data-spclst-featured-collection-prev]', sliderRoot);
      var nextButton = query('[data-spclst-featured-collection-next]', sliderRoot);
      var maxScrollLeft = 0;
      var cardsPerPage = 1;
      var pageStartPositions = [];
      var currentPage = 0;
      var ticking = false;
      var metricsRaf = null;
      var resizeObserver = null;

      if (!viewport || !track || !slides.length) return;

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }

      function getGapValue() {
        var computed = window.getComputedStyle(track);
        var gap = parseFloat(computed.columnGap || computed.gap || '0');
        return isNaN(gap) ? 0 : gap;
      }

      function getCardsPerPage() {
        var firstSlide = slides[0];
        if (!firstSlide) return 1;
        var firstSlideWidth = firstSlide.getBoundingClientRect().width || 1;
        return Math.max(1, Math.floor((viewport.clientWidth + getGapValue()) / (firstSlideWidth + getGapValue())));
      }

      function updateMetrics() {
        if (!slides.length) return;
        sliderRoot.style.setProperty('--spclst-featured-viewport-width', viewport.clientWidth + 'px');
        var viewportStyles = window.getComputedStyle(viewport);
        var viewportPaddingLeft = parseFloat(viewportStyles.paddingLeft || '0');
        if (isNaN(viewportPaddingLeft)) viewportPaddingLeft = 0;
        cardsPerPage = 1;
        maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);

        var rawPageStarts = [];
        for (var i = 0; i < slides.length; i += cardsPerPage) {
          var slideOffset = (slides[i].offsetLeft || 0) - viewportPaddingLeft;
          rawPageStarts.push(clamp(slideOffset, 0, maxScrollLeft));
        }

        if (!rawPageStarts.length) {
          rawPageStarts = [0];
        }

        var lastVisibleStartIndex = Math.max(0, slides.length - cardsPerPage);
        var lastVisibleOffset = (slides[lastVisibleStartIndex].offsetLeft || 0) - viewportPaddingLeft;
        rawPageStarts.push(clamp(lastVisibleOffset, 0, maxScrollLeft));
        rawPageStarts.push(maxScrollLeft);
        rawPageStarts.sort(function (a, b) {
          return a - b;
        });

        pageStartPositions = rawPageStarts.filter(function (value, index, list) {
          if (!index) return true;
          return Math.abs(value - list[index - 1]) > 1;
        });

        if (!pageStartPositions.length) {
          pageStartPositions = [0];
        }
      }

      function getClosestPageFromScroll() {
        var currentLeft = viewport.scrollLeft || 0;
        var closestPage = 0;
        var closestDistance = Infinity;
        pageStartPositions.forEach(function (pageLeft, index) {
          var distance = Math.abs(pageLeft - currentLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestPage = index;
          }
        });
        return closestPage;
      }

      function syncArrowState() {
        var noOverflow = maxScrollLeft <= 2;
        if (prevButton) prevButton.disabled = noOverflow;
        if (nextButton) nextButton.disabled = noOverflow;
      }

      function syncUI() {
        currentPage = getClosestPageFromScroll();
        syncArrowState();
      }

      function scrollToPage(pageIndex, behavior) {
        updateMetrics();
        var maxPage = Math.max(0, pageStartPositions.length - 1);
        currentPage = clamp(currentPage, 0, maxPage);
        if (maxScrollLeft <= 2) {
          currentPage = 0;
          viewport.scrollTo({ left: 0, behavior: behavior || 'auto' });
          syncArrowState();
          return;
        }
        var safeIndex = clamp(pageIndex, 0, maxPage);
        currentPage = safeIndex;
        var targetLeft = clamp(pageStartPositions[safeIndex] || 0, 0, maxScrollLeft);
        viewport.scrollTo({
          left: targetLeft,
          behavior: behavior || 'smooth',
        });
        syncArrowState();
      }

      function scrollByStep(direction) {
        var maxPage = Math.max(0, pageStartPositions.length - 1);
        if (maxPage <= 0) {
          scrollToPage(0, 'auto');
          return;
        }

        currentPage = getClosestPageFromScroll();
        var targetPage = currentPage + direction;
        if (targetPage > maxPage) targetPage = 0;
        if (targetPage < 0) targetPage = maxPage;
        scrollToPage(targetPage, 'smooth');
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          scrollByStep(-1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scrollByStep(1);
        });
      }

      viewport.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            syncUI();
            ticking = false;
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        updateMetrics();
        scrollToPage(currentPage, 'auto');
      });

      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(function () {
          if (metricsRaf) return;
          metricsRaf = window.requestAnimationFrame(function () {
            updateMetrics();
            scrollToPage(currentPage, 'auto');
            metricsRaf = null;
          });
        });
        resizeObserver.observe(viewport);
        resizeObserver.observe(track);
      }

      updateMetrics();
      window.requestAnimationFrame(function () {
        updateMetrics();
        scrollToPage(0, 'auto');
        syncUI();
      });
    });
  };
})();
